import { withSvgIcon } from './withSvgIcon';

export const LockOpen = withSvgIcon(
  <>
    <path
      d="M14 12H6C4.89543 12 4 12.8954 4 14V19C4 20.1046 4.89543 21 6 21H14C15.1046 21 16 20.1046 16 19V14C16 12.8954 15.1046 12 14 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M13 12V7C13 4.79086 14.7909 3 17 3C19.2091 3 21 4.79086 21 7V8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
